import { Box, Typography } from '@mui/material';
import React from 'react';
import { Card } from '../../Library/Card';
import { colors } from '../../../utils/theme';

interface TestImportanceCardProps {
  title: string;
  description: string;
}

export const TestImportanceCard = ({
  cardDetails,
}: {
  cardDetails: TestImportanceCardProps;
}): JSX.Element => {
  return (
    <Box>
      <Card
        title={cardDetails.title}
        icon="lightbulb02"
        content={
          <Box sx={{ mt: 2 }}>
            <Typography fontSize={14} variant="light">
              {cardDetails.description}
            </Typography>
          </Box>
        }
        cardStyles={{
          background: colors.greens.SUCCESS_100,
          color: colors.greys.BRAND_BLACK,
        }}
      />
    </Box>
  );
};
